export * from "./List";

// @TODO:
// Nakon refaktora List komponente na legacy AC-u i Next-u, obrisati individualne exporte.
// Korisčenje će se svesti samo na `import { List } from @activecollab/components`.

// <List>
//   <List.Item>Hello</List.Item>
//   ...
//   <List.Separator />
//   ...
// </List>
export * from "./ListItem";
export * from "./ListSeparator";
